/* eslint-disable jsx-a11y/anchor-is-valid */

//#region imports
import { PageProps } from "../App";
//#endregion

//#region component definition
export const Page: React.FC<PageProps> = (props: PageProps) => {
  return (
    <section className={`page-wrapper ${props.wrapperClass ? props.wrapperClass : ''}`}>
      {props.children ? props.children.map(child => child) : null}
      <section className={`page ${props.pageClass}`}>
        <h1 className={props.titleClass}>{props.title}</h1>
        {
          props.content.map((line: any) => {
            if (typeof(line) === 'string')
              return <p className={props.contentClass ? props.contentClass : ''}>{line}</p>;
            return (
              <ul>
                {
                  line.map((bullet: string) => {
                    return (
                      <li className={props.contentClass ? props.contentClass : ''}>
                        {
                          bullet.split('\n').map(element => {
                            return (
                              <>
                                {element}
                                <br/>
                              </>
                            )
                          })
                        }
                      </li>
                    )
                  })
                }
              </ul>
            );
          })
        }
      </section>
    </section>
  );
}
//#endregion